import { render, staticRenderFns } from "./Sticky.vue?vue&type=template&id=34725e3f&scoped=true&"
import script from "./Sticky.vue?vue&type=script&lang=js&"
export * from "./Sticky.vue?vue&type=script&lang=js&"
import style0 from "./Sticky.vue?vue&type=style&index=0&id=34725e3f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34725e3f",
  null
  
)

export default component.exports